import React, { useState, useContext } from "react";
import axios from "axios";
import { AuthContext } from "../contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import "../css/LoginSignUpPage.css";

const LoginSignUpPage = () => {
  const [isLogin, setIsLogin] = useState(true);
  const [formData, setFormData] = useState({
    username: "",
    email: "",
    password: "",
  });
  // ✨ 1. Add state for loading and errors
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const { login } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(""); // Clear previous errors

    const api_url = process.env.REACT_APP_API_URL || "http://localhost:5000";

    try {
      if (isLogin) {
        const response = await axios.post(`${api_url}/api/auth/login`, {
          email: formData.email,
          password: formData.password,
        });
        login(response.data);
        navigate("/");
      } else {
        await axios.post(`${api_url}/api/auth/signup`, {
          username: formData.username,
          email: formData.email,
          password: formData.password,
        });
        alert("User created successfully! Please log in.");
        setIsLogin(true);
        setFormData({ username: "", email: "", password: "" }); // Clear form
      }
    } catch (err) {
      // ✨ 2. Improved error handling
      console.error("Authentication error:", err.response);
      if (err.response?.data?.errors) {
        // Handle validation errors from the backend
        const errorMsg = err.response.data.errors.map((e) => e.msg).join(". ");
        setError(errorMsg);
      } else if (err.response?.data?.message) {
        // Handle other specific messages (e.g., "Invalid credentials")
        setError(err.response.data.message);
      } else {
        setError("An unexpected error occurred. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  const handleGoogleLogin = () => {
    const api_url = process.env.REACT_APP_API_URL || "http://localhost:5000";
    window.location.href = `${api_url}/api/auth/google`;
  };

  return (
    <div className="login-signup-page container animate__animated animate__fadeIn">
      <div className="auth-panel">
        <form onSubmit={handleSubmit} className="auth-form">
          {/* ✨ 3. Conditionally render the Username input for Sign Up only */}
          {!isLogin && (
            <input
              type="text"
              placeholder="Username"
              className="form-control"
              value={formData.username}
              onChange={(e) =>
                setFormData({ ...formData, username: e.target.value })
              }
              required
            />
          )}

          <input
            type="email"
            placeholder="Email"
            className="form-control"
            value={formData.email}
            onChange={(e) =>
              setFormData({ ...formData, email: e.target.value })
            }
            required
          />

          <input
            type="password"
            placeholder="Password"
            className="form-control"
            value={formData.password}
            onChange={(e) =>
              setFormData({ ...formData, password: e.target.value })
            }
            required
          />

          {/* ✨ 4. Display the error message to the user */}
          {error && <div className="auth-error">{error}</div>}

          <div className="action-toggle">
            <button
              type="button"
              className={isLogin ? "toggle-btn active" : "toggle-btn"}
              onClick={() => {
                setIsLogin(true);
                setError(""); // Clear error on toggle
              }}
            >
              Login
            </button>
            <button
              type="button"
              className={!isLogin ? "toggle-btn active" : "toggle-btn"}
              onClick={() => {
                setIsLogin(false);
                setError(""); // Clear error on toggle
              }}
            >
              Sign Up
            </button>
          </div>

          <button type="submit" className="btn-submit" disabled={loading}>
            {loading ? "Processing..." : isLogin ? "Login" : "Sign Up"}
          </button>

          <button
            type="button"
            className="btn-google"
            onClick={handleGoogleLogin}
            disabled={loading}
          >
            {isLogin ? "Login with Google" : "Sign Up with Google"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginSignUpPage;
